import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { DefaultMetaDataServiceImpl } from '../../interfaces/DefaultMetaDataServiceImpl';
import { BaseMetaDataService } from './base-meta-data.service';

@Injectable({ providedIn: 'root' })
export class InveniasMetaDataService extends BaseMetaDataService {
  constructor(http: HttpClient) {
    super(http, Namespace.invenias, new DefaultMetaDataServiceImpl());
  }
}
